module.exports = __webpack_public_path__ + "static/media/appointment-tabs.5f68ccd1.svg";